import { Outlet } from "react-router-dom";

export default function BaseLayout() {
  return (
    <div className="container-fluid bg-light">
      <Outlet />
    </div>
  );
}
